import React from "react";
import { BaseIcon, BaseIconProps } from "./baseIcon";

export const RwaIcon = React.forwardRef<SVGSVGElement, BaseIconProps>(
  (props, ref) => {
    const { opacity = 1, ...rest } = props;

    return (
      <BaseIcon ref={ref} {...rest} viewBox="0 0 12 12">
        <path
          d="M6 1a5 5 0 0 1 4.999 5H11l-.002.047-.002.121a5 5 0 0 1-.049.552 5 5 0 0 1-.596 1.742l-.025.044-.086.143-.023.035q-.044.072-.093.142l-.021.03q-.145.208-.31.4l-.071.082a5 5 0 0 1-.403.4l-.074.064-.1.085-.063.049q-.056.044-.114.087l-.052.037q-.31.223-.656.399l-.01.006A5 5 0 0 1 6 11a5 5 0 0 1-3.582-1.511L1.5 10.5.75 7.25l3.25.5-.906.996A4 4 0 0 0 6 10c.834 0 1.609-.256 2.25-.693v-.002c.381-.272.718-.6 1-.975a8 8 0 0 0-1-.19 8 8 0 0 1-.151.57.244.244 0 0 1-.302.16l-.481-.138a.256.256 0 0 1-.172-.32q.051-.177.101-.367c-.172 0-.343-.014-.52-.024a.26.26 0 0 1-.245-.256V7.25c0-.138.112-.25.25-.249.237.002.469.01.695.044Q7.492 6.524 7.5 6q0-.532-.06-1.06C7 5 6.5 5 6 5s-.975 0-1.44-.055Q4.495 5.47 4.5 6v.187a.247.247 0 0 1-.272.246 17 17 0 0 1-.515-.062.25.25 0 0 1-.213-.246V6a10 10 0 0 1 .06-1.155 8 8 0 0 1-1.295-.27c-.18.453-.27.687-.265 1.175v.01c0 .16-.147.278-.302.243q-.255-.057-.5-.116a.24.24 0 0 1-.187-.25A5 5 0 0 1 6 1m3.73 3.581a9 9 0 0 1-1.3.259 9.7 9.7 0 0 1 0 2.315q.665.078 1.31.264c.144-.38.233-.787.255-1.213L10 6a3.8 3.8 0 0 0-.27-1.419M6 2c-.47 0-1 .83-1.275 1.955C5.13 4 5.555 4 6 4s.865 0 1.27-.035C7 2.795 6.46 2 6 2m-1.772.413a4 4 0 0 0-1.493 1.262q.495.122 1 .19c.098-.504.264-.992.493-1.452m3.548 0q.326.7.499 1.452.505-.066 1-.185a4.4 4.4 0 0 0-1.499-1.266"
          fill="currentColor"
          fillOpacity={opacity}
        />
      </BaseIcon>
    );
  },
);

RwaIcon.displayName = "RwaIcon";
